module.exports = __webpack_public_path__ + "img/icons-zaki.dab4fd3.svg";